import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import {BrowserRouter} from "react-router-dom";
import ActionsMain, {Parent} from "./testcomponents/ActionsParent";
import MainComponent from "./components/MainComponent";
import MyTable from "./testcomponents/MyTable";

ReactDOM.render(
    // use StrictMode !!!!
    // see https://stackoverflow.com/a/62739854/1659599
    // <React.StrictMode>
    <BrowserRouter>
        {/*<ActionsMain></ActionsMain>*/}
        <MainComponent></MainComponent>
        {/*<MyTable></MyTable>*/}
    </BrowserRouter>,
    // <TestReactMarkdown ploneParams={{s: "Wie {lange|oft} ein Studium in der {Regel} {dauert}."}}/>,
    // </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
